/**
 * Default-off rollout gate for claims authority (CUR-1633). Organisation-scoped: every
 * member of an organisation sees the same answer, so a level set by one administrator is
 * never invisible to another.
 */
export const ENABLE_CLAIMS_AUTHORITY_FLAG = 'enable-claims-authority';

/**
 * Default-off rollout gate for payment approval (CUR-2647). Organisation-scoped like
 * `ENABLE_CLAIMS_AUTHORITY_FLAG`, and needs it: payments are authorised and signed off against the
 * same levels and reporting lines.
 */
export const ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG = 'enable-claim-payment-approval';

/** The largest limit a level can carry. Matches the `Decimal(14, 2)` columns with room to spare. */
export const MAX_CLAIM_AUTHORITY_LIMIT = 999_999_999.99;

export const CLAIM_AUTHORITY_LEVEL_NAME_MAX_LENGTH = 80;

/** CUR-1643: the longest insurer reference recorded with an insurer-approved referral. */
export const CLAIM_RESERVE_INSURER_REFERENCE_MAX_LENGTH = 100;

/**
 * CUR-2673: the longest note a payment decision takes (a decline reason, what needs correcting on a
 * return, a reason for withdrawing), as a reserve change's decline reason.
 */
export const PAYMENT_DECISION_NOTE_MAX_LENGTH = 2_000;

/** CUR-2673: the longest payment reference recorded when a payment is marked as paid (PAY-A9). */
export const PAYMENT_REFERENCE_MAX_LENGTH = 100;

/**
 * The most members one organisation's list of people returns. The list is read whole so the
 * page can search and filter it without a round trip; an organisation past this size needs
 * a paged list first.
 */
export const CLAIM_AUTHORITY_PEOPLE_LIMIT = 2000;
